import * as THREE from 'three'
import Experience from '@experience/Experience.js'
import Debug from '@experience/Utils/Debug.js'
import Properties from "@experience/Properties.js";
import Resources from "@experience/Utils/Resources.js";
import * as helpers from "@experience/Utils/HelpersFunctions.js";
import Ui from "@experience/Ui/Ui.js";
import Model from "./Abstracts/Model.js";

export default class NervousSystem extends Model{
    experience = new Experience()
    debug = new Debug()
    properties = new Properties()
    scene = experience.scene
    time = experience.time
    camera = experience.camera.instance
    renderer = experience.renderer.instance
    resources = experience.resources
    cursor = experience.cursor
    timeline = experience.timeline;

    loadingModel = false;

    ui = new Ui()
    container = new THREE.Group();

    sources = [ {
        name: 'nervousSystemModel',
        type: 'gltfModel',
        path: 'models/nervous_system_low2/nervous_system_low2.gltf'
    } ]

    sourcesReady = 'NervousSystemReady'

    constructor( body ) {
        super()
        this.body = body
    }

    setModel() {
        this.nervousSystemModel = this.resources.items.nervousSystemModel.scene

        helpers.meshToBatchedMesh( this.nervousSystemModel, this.container, this.body.batchedMeshesIds )

        //this.body.changeVisibility( this.nervousSystemModel, false )

        //this.container.add( this.nervousSystemModel );
        //helpers.cloneAllMaterials( this.container );
        this.body.container.add( this.container );
    }


    resize() {

    }

    setDebug() {
        if ( !this.debug.active ) return
    }

    update( deltaTime ) {

    }

}
